module.exports = __webpack_public_path__ + "img/denmark-pregnancy-childbirth-and-the-puerperium-female.6a7821bd.png";